import { Component } from '@angular/core';

@Component({
  selector: 'app-pass-key-rename-success',
  templateUrl: './pass-key-rename-success.component.html',
  styleUrl: './pass-key-rename-success.component.scss',
  standalone: false,
})
export class PassKeyRenameSuccessComponent {
    isSuccess: boolean;
}
